// @packages
import { Auth } from 'aws-amplify';
import { AxiosError } from 'axios';

// @scripts
import { Durations, IUserState } from '../utils/types';
import { globalUI } from '../core';
import { getAttributes } from '../utils/user';

export async function signIn(userName: string, password: string): Promise<IUserState> {
  try {
    const user = await Auth.signIn(userName, password);
    return getAttributes(user, userName);
  } catch (error) {
    const err = error as AxiosError;
    globalUI.showToast(err.message, Durations.SHORT);
    throw error;
  }
}

export async function forgotPassword(userName: string) {
  try {
    const resp = await Auth.forgotPassword(userName);
    return resp;
  } catch (error) {
    const err = error as AxiosError;
    globalUI.showToast(err.message, Durations.SHORT);
    throw error;
  }
}

export async function forgotPasswordSubmit(userName: string, code: string, newPassword: string) {
  try {
    const resp = await Auth.forgotPasswordSubmit(userName, code, newPassword);
    return resp;
  } catch (error) {
    const err = error as AxiosError;
    globalUI.showToast(err.message, Durations.SHORT);
    throw error;
  }
}

export async function logout() {
  try {
    await Auth.signOut();
  } catch (error) {
    const err = error as AxiosError;
    globalUI.showToast(err.message, Durations.SHORT);
    throw error;
  }
}

export async function completeNewPassword(userName: string, password: string, newPassword: string) {
  try {
    const user = await Auth.signIn(userName, password);
    await Auth.completeNewPassword(user, newPassword);
    delete user.challengeName;
    return getAttributes(user, userName);
  } catch (error) {
    const err = error as AxiosError;
    globalUI.showToast(err.message, Durations.SHORT);
    return null;
  }
}
